import { ApiService, IConfig } from "qccat-ui";
import { WebServiceUrl, LoginUrl, NotifyRequestRejectedUrl } from "../config/appUrlConfig";

export const qoolApiService = new ApiService( { apiUrl: WebServiceUrl, loginUrl: LoginUrl, notifyRequestRejectedUrl: NotifyRequestRejectedUrl });